import src from "IMAGE";
export default { src, width: 409, height: 124, blurWidth: 0, blurHeight: 0};
